import React from 'react';
import styled from 'styled-components';
import { NewsletterSignup } from '../../components';

const DemoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const DemoTitle = styled.h1`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin: 0;
`;

const NewsletterDemo: React.FC = () => {
  return (
    <DemoContainer>
      <DemoTitle>Niyyah Newsletter Signup Demo</DemoTitle>
      <NewsletterSignup />
    </DemoContainer>
  );
};

export { NewsletterDemo };
